import { isBrowser } from './isBrowser';

export const isAUNZ = isBrowser
  ? window.location.href.includes('/au/') || window.location.href.includes('/nz/')
  : false;
